import React from "react";

const ViewWorkflowInterestRequest = () => {
  return <div>ViewWorkflowInterestRequest</div>;
};

export default ViewWorkflowInterestRequest;
